import { Channel } from '@/domain/bot';

const ROOT = 'cmb';

const DEFAULT_CHANNEL: Channel = 'voice';

const CHANNEL_MCHANNELS_BOT_ID_MAPPING: Record<Channel, string> = {
    voice: `maria-${ROOT}`,
    sms: `sms-${ROOT}`,
};

const DEFAULT_MCHANNELS_BOT_ID =
    CHANNEL_MCHANNELS_BOT_ID_MAPPING[DEFAULT_CHANNEL];

const MCHANNELS_BOT_ID_DEV_SUFFIX = '-dev';

export {
    DEFAULT_CHANNEL,
    DEFAULT_MCHANNELS_BOT_ID,
    CHANNEL_MCHANNELS_BOT_ID_MAPPING,
    MCHANNELS_BOT_ID_DEV_SUFFIX,
};
